import React, { Component } from 'react';
import { CircularProgress, Button, TextField } from '@material-ui/core';

function properCase(myString){
    return myString.substring(0,1).toUpperCase() + myString.substring(1,myString.length).toLowerCase();
}

function mobileValid (mobile) {
    if (/^\d{10}$/.test(mobile)){
      if ((mobile.substring(0, 3)==="010" || mobile.substring(0, 2)==="08" || mobile.substring(0, 2)==="07" || mobile.substring(0, 2)==="06" || mobile.substring(0, 2)==="07")&& !(mobile.substring(0, 3)==="086" || mobile.substring(0, 3)==="088" || mobile.substring(0, 3)==="089") ){
        return true
      } else {
        return false;
      }
    } else {
      return false;
    } 
}


class NameNum extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showSpinner: false,
            status: '',
            warning: '',
            f_name: '',
            fn_pholder: 'first name',
            l_name: '',
            ln_pholder: 'last name',
            mobile_num: '',
            m_pholder: 'Mobile Number (Cell)',
            canSubmit: true,
        }
    }
    
    render() {
        return (
            <div>
                <p>Please tell us who you are and provide a mobile contact number...</p>
                <form name="NameNumber" method="POST" onSubmit={this.submitHandler}  autoComplete='off'>

                    <TextField 
                        variant='outlined'
                        disabled={!this.state.canSubmit}
                        type="text"
                        id="fname"
                        name="fname"
                        label={this.state.fn_pholder}
                        value={this.state.f_name}
                        // onFocus={()=> this.setState({fn_pholder:'',status:''})}
                        // onBlur={()=> this.setState({fn_pholder:'first name',status:''})}
                        onChange={this.fieldHandler}
                        required
                        InputProps={{pattern:"(^[A-Za-z]+[- ]?[A-Za-z]+)|[A-Za-z]"}}
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        style={{width:'40%', minWidth:'250px', marginTop:'10px'}}
                    />
                    <br/>
                    <TextField 
                        variant='outlined'
                        disabled={!this.state.canSubmit}
                        type="text"
                        id="lname"
                        name="lname"
                        label={this.state.ln_pholder}
                        value={this.state.l_name}
                        // onFocus={()=> this.setState({ln_pholder:'',status:''})}
                        // onBlur={()=> this.setState({ln_pholder:'last name',status:''})} 
                        onChange={this.fieldHandler}
                        required
                        InputProps={{pattern:"(^[A-Za-z]+[- ]?[A-Za-z]+)|[A-Za-z]"}}
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        style={{width:'40%', minWidth:'250px', marginTop:'10px'}}
                    />
                    <br/>
                    <TextField
                        variant='outlined'
                        disabled={!this.state.canSubmit}
                        type="tel"
                        id="mobile"
                        name="mobile"
                        label={this.state.m_pholder}
                        value={this.state.mobile_num}
                        // onFocus={()=> this.setState({m_pholder:'',status:''})}
                        // onBlur={()=> this.setState({m_pholder:'Mobile Number (Cell)',status:''})}
                        onChange={this.fieldHandler}
                        InputProps={{pattern:"[0-9]{10}"}}
                        required
                        title="Please enter your 10 digit mobile (cell) number without any spaces e.g. 0821234567"
                        autoComplete='off'
                        autoCorrect='off'
                        autoCapitalize='off'
                        style={{width:'40%', minWidth:'250px', marginTop:'10px'}}
                    />


                    {/* <div className="prime_input">
                        <input disabled={!this.state.canSubmit} type="text" id="fname" name="fname" placeholder={this.state.fn_pholder} value={this.state.f_name} onFocus={()=> this.setState({fn_pholder:'',status:''})} onBlur={()=> this.setState({fn_pholder:'first name',status:''})} onChange={this.fieldHandler} required pattern="(^[A-Za-z]+[- ]?[A-Za-z]+)|[A-Za-z]" autoComplete='off' autoCorrect='off' autoCapitalize='off' />
                    </div> */}
                    {/* <div className="prime_input">
                        <input disabled={!this.state.canSubmit} type="text" id="lname" name="lname" placeholder={this.state.ln_pholder} value={this.state.l_name} onFocus={()=> this.setState({ln_pholder:'',status:''})} onBlur={()=> this.setState({ln_pholder:'last name',status:''})} onChange={this.fieldHandler} required pattern="(^[A-Za-z]+[- ]?[A-Za-z]+)|[A-Za-z]" autoComplete='off' autoCorrect='off' autoCapitalize='off'/>
                    </div> */}
                    {/* <div className="prime_input">
                        <input disabled={!this.state.canSubmit} type="tel" id="mobile" name="mobile" placeholder={this.state.m_pholder} value={this.state.mobile_num} onFocus={()=> this.setState({m_pholder:'',status:''})} onChange={this.fieldHandler} onBlur={()=> this.setState({m_pholder:'Mobile Number (Cell)',status:''})} pattern="[0-9]{10}" required title="Please enter your 10 digit mobile (cell) number without any spaces e.g. 0821234567" autoComplete='off' autoCorrect='off' autoCapitalize='off'/>
                    </div> */}

                    <br/>

                    {/* <button id="Submit" className="button" style={{verticalAlign:'middle'}} disabled={!this.state.canSubmit}><span id="s1" >Submit</span></button> */}
                    <Button 
                        variant='contained'
                        size='large'
                        color='primary'
                        id="Submit"
                        disabled={!this.state.canSubmit}
                        type='submit'
                        style={{marginTop:'15px'}}
                    >
                        <span id="s1" >Submit</span>
                    </Button>
                   
                </form>
                <hr/>
                <span id="StatusBar" className="StatusBar">
                    {this.state.showSpinner&&<CircularProgress size={30} />}&nbsp;&nbsp;
                    {this.state.status}
                </span>
                <span className='warningMessage'>{this.state.warning}</span>
            </div>
        );

    }
    
    submitHandler = (e) => {

        e.preventDefault();
        const fName = this.state.f_name;
        const lName = this.state.l_name;
        const Mobile = this.state.mobile_num;

        if (fName.length===1||fName.substring(1,2)===" "||lName.length===1||lName.substring(1,2)===" ") {
            this.setState({status:'', warning:"Please enter your full first and last names, not just your initial(s)..."});
            return false;
        } else if (fName.indexOf(" ")!==-1){
            this.setState({status:'',warning:"Please enter only a single first name (names may be hyphenated though)..."});
            return false;
        } else if (lName.indexOf(" ")!==-1){
            this.setState({status:'',warning:"Please enter only a single last name (names may be hyphenated though)..."});
            return false;
        } else if (!mobileValid(Mobile)){
            this.setState({status:'',warning:"The mobile (cell) number you have entered does not appear to be a mobile number...please enter a valid mobile number"});
            return false;
        } else if (Mobile==="0821234567"){
            this.setState({status:'',warning:"You seem to have entered our sample mobile number by mistake...please enter your mobile (cell) number"});
            return false;
        } else {
            // console.log('Good to go...');
            this.setState({status:"processing...",showSpinner:true,canSubmit:false});
            this.props.setParentState({fname:fName,lname:lName,mobile:Mobile,showNameNum:false,showOTPDialogue:true});
            return true;
        }
    }

    fieldHandler = (e) => {
       
        if (e.target.name==='mobile'){this.setState({mobile_num:e.target.value})}
        if (e.target.name==='fname'){this.setState({f_name: properCase(e.target.value)})}
        if (e.target.name==='lname'){this.setState({l_name: properCase(e.target.value)})}
        // console.log('change on => ',e.target.name);
    }

}

export default NameNum;